import {CompetitionMedalsPageRouteMetaDataModel} from "./competition-medals-page.route.meta-data.model";
import {PAGES} from "../../../../../core/consts";
import {CompetitionPageRouteConfig} from "../../../models/competition.page-route.config";

export class CompetitionMedalsPageRouteConfig extends CompetitionPageRouteConfig {
  static injectables = [];

  constructor() {
    super({
      name: PAGES.COMPETITION.medals,
      path: `medals`,
      componentImport: () => import("../components/competition-medals-page" /* webpackChunkName: "competition-medals-page" */ ),
      metadataType: CompetitionMedalsPageRouteMetaDataModel
    });
  }
}
